module.exports = __webpack_public_path__ + "static/man2-0bf5e0c62295b177be59e36f11c5d60e.png";